import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { customerApi } from '../api/customerApi';
import { ToastMessage } from '../components/ToastMessage';

export const CUSTOMER_BENEFITS_QUERY_KEY = ['customer-benefits'];

export const useCustomerBenefits = (enabled: boolean, customerId: string) => {
  return useQuery({
    queryKey: [...CUSTOMER_BENEFITS_QUERY_KEY, customerId],
    queryFn: () => customerApi.fetchBenefits(customerId),
    enabled,
    refetchOnWindowFocus: false,
  });
};

type UpdateBenefitSubscriptionParams = {
  slug: string;
  subscriptionId: number;
  isActiveBenefit: boolean;
  customerId: string;
};

export const useUpdateBenefitSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      slug,
      subscriptionId,
      isActiveBenefit,
      customerId,
    }: UpdateBenefitSubscriptionParams) =>
      customerApi.updateBenefitSubscription(
        slug,
        subscriptionId,
        isActiveBenefit,
        customerId
      ),
    onSuccess: async (_, variables) => {
      ToastMessage({
        content: variables.isActiveBenefit
          ? 'Benefício reativado com sucesso!'
          : 'Benefício desativado com sucesso!',
        type: 'success',
      });
      await queryClient.invalidateQueries({
        queryKey: CUSTOMER_BENEFITS_QUERY_KEY,
      });
    },
    onError: (_, variables) => {
      ToastMessage({
        content: variables.isActiveBenefit
          ? 'Falha ao reativar o benefício. Tente novamente!'
          : 'Falha ao desativar o benefício. Tente novamente!',
        type: 'error',
      });
    },
  });
};
